/*
  Define the urls
*/
import state from '@bingads-webui-component-legacy/state/index';

export function getCampaignWithCidAndAid(cid, aid) {
  return `/campaign/Campaigns?cid=${cid}&uid=${state.get('user_id')}&aid=${aid}`;
}

export function getCampaignWithAid(aid) {
  return `/campaign/Campaigns?cid=${state.get('customer_id')}&uid=${state.get('user_id')}&aid=${aid}`;
}

export function getAccountsSummaryWithCid(cid) {
  return `/campaign/AccountsSummary?cid=${cid}&uid=${state.get('user_id')}`;
}
